module.exports = __webpack_public_path__ + "img/contacts.feea9f5a.svg";